// NotificationsPanel — bell-driven side panel with recent activity stream.

import { Drawer } from "@/components/primitives/Drawer";
import { useUiStore } from "@/store/ui";

interface NotificationEntry {
  id: string;
  title: string;
  meta: string;
  emphasis?: string;
}

const SAMPLE: NotificationEntry[] = [
  { id: "n1", title: "17 FactSet mappings flagged stale by Copilot.", meta: "2 minutes ago", emphasis: "Copilot" },
  { id: "n2", title: "Approval queue: 4 high-priority requests.", meta: "12 minutes ago" },
  { id: "n3", title: "Bloomberg feed reconnected after 2m outage.", meta: "1 hour ago" },
  { id: "n4", title: "Quality rule 'CCY-ISO' now passing 100% on instruments.", meta: "3 hours ago" },
];

export function NotificationsPanel() {
  const open = useUiStore(s => s.notificationsOpen);
  const setOpen = useUiStore(s => s.setNotificationsOpen);
  return (
    <Drawer open={open} onClose={() => setOpen(false)} title="Notifications" width={420}>
      <ul className="lex-notif-list" style={{ listStyle: "none", margin: 0, padding: 0 }}>
        {SAMPLE.map(n => (
          <li key={n.id}>
            <div>
              <div className="lex-notif-list__line">{n.title}</div>
              <div className="lex-notif-list__meta">{n.meta}</div>
            </div>
          </li>
        ))}
      </ul>
    </Drawer>
  );
}

export default NotificationsPanel;
